import React from "react";

const NotFound = () => {
    return <h1>Page NotFound</h1>;
};

export default NotFound;
